import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {DinaUppgifterService} from '../../../services/dina-uppgifter.service';
import {PageChangedEvent} from 'ngx-bootstrap/pagination';
import {Subscription} from 'rxjs';
import {ModalTableAlertComponent} from '../../../shared/modals/modal-table-alert/modal-table-alert.component';
import {SammanstallningStoreService} from '../../../stores/sammanstallning.store';
import {InkomstTableItem} from '../../../shared/models/inkomst-table-item.model';
import {ModalService} from '../../../services/modal/modal.service';

@Component({
  selector: 'app-tabel',
  templateUrl: './table.component.html',
  styleUrls: []
})
export class TableComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  loading = false;

  currentPage = 1;
  startItem = 0;
  endItem = 10;

  constructor(
    public dittUnderlagService: DinaUppgifterService,
    public sammanstallningStoreService: SammanstallningStoreService,
    private readonly modalService: ModalService,
    private readonly cd: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.dittUnderlagService.onUpdate$.subscribe((id) => {
        this.sammanstallningStoreService.deselectCurrentItem();
      })
    );

    this.subscriptions.push(
      this.dittUnderlagService.loading$.subscribe((loading: boolean) => {
        this.loading = loading;
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  onEdit(id: number, isSelected: boolean) {
    if (isSelected && this.dittUnderlagService.isFormDirty()) {
      // Klickar på en annan rad
      this.modalService.openAlert('form-modal-1', () => {
        this.sammanstallningStoreService.deselectCurrentItem();
        this.dittUnderlagService.resetForm();
        this.dittUnderlagService.edit(id);
        this.sammanstallningStoreService.setSelected(id, isSelected);
      });
    } else if (this.dittUnderlagService.isFormDirty()) {
      // Klickar på samma rad
      this.modalService.openAlert('form-modal-2', () => {
        this.sammanstallningStoreService.setSelected(id, isSelected);
        this.dittUnderlagService.resetForm();
      });
    } else if (isSelected) {
      this.sammanstallningStoreService.deselectCurrentItem();
      this.sammanstallningStoreService.setSelected(id, isSelected);
      this.dittUnderlagService.edit(id);
    } else {
      this.sammanstallningStoreService.deselectCurrentItem();
      this.dittUnderlagService.resetForm();
    }
  }

  onRemove(item: InkomstTableItem) {
    // Flytta till dinaUppgifterService
    if (item.isSelected && this.dittUnderlagService.isFormDirty()) {
      const texts = [
        'Du försöker ta bort en uppgift som du håller på att ändra.',
        'Vill du ta bort uppgiften från sammanställningen?'
      ];
      this.modalService.openModalTabelAlert('table-modal-1', texts, item, ModalTableAlertComponent,
        () => {
          this.sammanstallningStoreService.deselectCurrentItem();
          this.dittUnderlagService.removeUnderlag(item.id);
          this.currentPage = this.currentPage + 0; // Triggar onPageChanged eventet
          this.cd.detectChanges();
        });
      return;
    }

    this.modalService.openModalTabelAlert(
      'table-modal-2', ['Vill du ta bort uppgiften från sammanställningen?'], item, ModalTableAlertComponent,
      () => {
        this.dittUnderlagService.removeUnderlag(item.id);
        this.currentPage = this.currentPage + 0; // Triggar onPageChanged eventet
        this.cd.detectChanges();
      });
  }

  onPageChanged(event: PageChangedEvent): void {
    this.startItem = (event.page - 1) * event.itemsPerPage;
    this.endItem = event.page * event.itemsPerPage;
  }

  unsubscribe(): void {
    this.subscriptions.forEach((s: Subscription) => {
      s.unsubscribe();
    });
    this.subscriptions = [];
  }
}
